import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { BIODIVERSITY_API } from './config';

export function getList(query) {
  return getFetch(`${BIODIVERSITY_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${BIODIVERSITY_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${BIODIVERSITY_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${BIODIVERSITY_API()}/${_id}`);
}

export function create(data) {
  return postFetch(`${BIODIVERSITY_API()}`, data);
}

export function exportData(query) {
  return getFetch(`${BIODIVERSITY_API()}/export`, query);
}



// WEBPACK FOOTER //
// ./src/api/biodiversityApi.js